import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import {
  DxButtonModule,
  DxSelectBoxModule,
  DxTextAreaModule,
  DxTagBoxModule,
  DxDateBoxModule,
  DxValidatorModule,
  DxDateRangeBoxModule,
  DxTextBoxModule,
  DxResponsiveBoxModule,
  DxFormModule,
  DxDataGridModule,
  DxBoxModule,
  DxFileUploaderModule,
  DxCheckBoxModule,
} from "devextreme-angular";
import { UIUtils } from "../../services/uiutils.service";
import { Router } from "@angular/router";
import { SessionValues } from "../../services/sessionvalues.service";
import { ServerCommunicatorService } from "../../services/server-communicator.service";
import { ClickEvent } from "devextreme/ui/button";
import { TransportData } from "../../classes/infrastructure/transportdata";
import { PayloadPacketFacade } from "../../classes/infrastructure/payloadpacket/payloadpacketfacade";
import { PasswordChangeCustomRequest } from "../../classes/domain/entities/website/passwordchange/passwordchangecustomrequest";
import { AppStateManageService } from "../../services/app-state-manage.service";
import { TranslateService } from "@ngx-translate/core";
import { LanguageService } from "../../services/language.service";

@Component({
  selector: "app-password-change",
  templateUrl: "./password-change.component.html",
  styleUrl: "./password-change.component.scss",
  standalone: true,
  imports: [
    DxButtonModule,
    DxSelectBoxModule,
    DxTextAreaModule,
    DxTagBoxModule,
    DxDateBoxModule,
    DxValidatorModule,
    DxDateRangeBoxModule,
    DxTextBoxModule,
    FormsModule,
    DxResponsiveBoxModule,
    DxFormModule,
    CommonModule,
    ReactiveFormsModule,
    DxDataGridModule,
    DxBoxModule,
    DxCheckBoxModule,
    DxFileUploaderModule,
  ],
})
export class PasswordChangeComponent {
  loading = false;
  formData: any = { OldPassword: "", NewPassword: "", ConfirmPassword: "" };

  constructor(
    private router: Router,
    private uiUtils: UIUtils,
    private sessionValues: SessionValues,
    private serverCommunicator: ServerCommunicatorService,
    private payloadPacketFacade: PayloadPacketFacade,
    private appStateManage: AppStateManageService,
    public langService: LanguageService,
            private translate: TranslateService
  ) { }

  oldpasswordMode = 'password';
  newpasswordMode = 'password';
  confirmpasswordMode = 'password';

  toggleOldPasswordVisibility = () => {
    this.oldpasswordMode = this.oldpasswordMode === 'text' ? 'password' : 'text';
  };

  toggleNewPasswordVisibility = () => {
    this.newpasswordMode = this.newpasswordMode === 'text' ? 'password' : 'text';
  };

  toggleComfirmPasswordVisibility = () => {
    this.confirmpasswordMode = this.confirmpasswordMode === 'text' ? 'password' : 'text';
  };

  async onSubmit() {
    const Ref = this.appStateManage.getLoginUserRef();
    console.log('Ref :', Ref);

    // if (this.formData.OldPassword == "") {
    //   await this.uiUtils.showInformationalMessage("Information", "Old Password not Specified");
    //   return;
    // } else if (this.formData.NewPassword == "") {
    //   await this.uiUtils.showInformationalMessage("Information", "New Password not Specified");
    //   return;
    // } else if (this.formData.confirmpassword == "") {
    //   await this.uiUtils.showInformationalMessage("Information", "Confirm Password not Specified");
    //   return;
    // }
    // else if (this.formData.NewPassword != this.formData.ConfirmPassword) {
    //   await this.uiUtils.showInformationalMessage("Information", "New Password & Confirm Password are not Same");
    //   return;
    // }

      const isMr = this.langService.currentLang === 'mr';

if (this.formData.OldPassword == "") {
  await this.uiUtils.showInformationalMessagelang(
    isMr ? 'माहिती' : 'Information',
    isMr ? 'जुना पासवर्ड दिलेला नाही' : 'Old Password not specified',
    undefined,
    isMr
  );
  return;

  } else if (this.formData.NewPassword == "") {
    await this.uiUtils.showInformationalMessagelang(
      isMr ? 'माहिती' : 'Information',
      isMr ? 'नवीन पासवर्ड दिलेला नाही' : 'New Password not specified',
       undefined,
    isMr
    );
    return;

  } else if (this.formData.confirmPassword == "") {
    await this.uiUtils.showInformationalMessagelang(
      isMr ? 'माहिती' : 'Information',
      isMr ? 'पासवर्डची पुष्टी दिलेली नाही' : 'Confirm Password not specified',
      undefined,
    isMr
    );
    return;

  } else if (this.formData.NewPassword != this.formData.ConfirmPassword) {
    await this.uiUtils.showInformationalMessagelang(
      isMr ? 'माहिती' : 'Information',
      isMr
        ? 'नवीन पासवर्ड आणि पुष्टी केलेला पासवर्ड जुळत नाही'
        : 'New Password & Confirm Password do not match',
        undefined,
    isMr
    );
    return;
  }

    let req = new PasswordChangeCustomRequest();
    req.login_token = this.sessionValues.CurrentLoginToken;
    req.app_type = "Admin";
    req.id = Ref;
    req.old_password = this.formData.OldPassword;
    req.new_password = this.formData.NewPassword;
    req.confirm_password = this.formData.ConfirmPassword;
    console.log('req :', req);
    let td = req.FormulateTransportData();
    let pkt = this.payloadPacketFacade.CreateNewPayloadPacket2(td);
    let tr = await this.serverCommunicator.sendHttpRequest(pkt);

    if (!tr.Successful) {
      await this.uiUtils.showErrorMessage('Error', tr.Message);
      return;
    }

    // await this.uiUtils.showSuccessToster('Password Created Successfully');
await this.uiUtils.showSuccessToster(
  isMr
    ? 'पासवर्ड यशस्वीरित्या तयार झाला'
    : 'Password created successfully'
);

    let tdResult = JSON.parse(tr.Tag) as TransportData;
    await this.router.navigate(['/login-form']);
  };

  Back = () => {
    this.router.navigate(['/home']);
  }
}


